@if (showBanner()) {
  <div class="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 flex justify-center animate-fade-in pointer-events-none">
    <div class="w-full max-w-4xl glass-card bg-dark-surface/95 backdrop-blur-xl border border-white/10 p-4 md:p-5 flex flex-col md:flex-row items-center justify-between gap-4 shadow-2xl relative overflow-hidden pointer-events-auto">
      
      <!-- Top Rainbow Line decoration -->
      <div class="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-rainbow-red via-rainbow-orange via-rainbow-yellow via-rainbow-green via-rainbow-blue to-rainbow-purple"></div>

      <!-- Icon & Text -->
      <div class="flex items-start space-x-3.5 text-left">
        <span class="text-2xl mt-0.5 select-none">🍪</span>
        <div class="space-y-1">
          <h4 class="text-xs font-bold text-white uppercase tracking-wider">Информация за бисквитките (Cookies)</h4>
          <p class="text-[11px] text-dark-text-muted leading-relaxed max-w-2xl">
            Този уебсайт използва строго необходими бисквитки и локално пространство за съхранение, за да поддържа входа в профила Ви и да запазва артикулите в количката Ви. С продължаването на сърфирането или натискането на бутона „Разбрах“, Вие се съгласявате с използването на тези функционални бисквитки.
          </p>
        </div>
      </div>

      <!-- Action Button -->
      <div class="shrink-0 flex items-center">
        <button (click)="acceptCookies()"
                class="bg-btn-rainbow text-white text-xs font-bold px-6 py-2.5 rounded-full shadow-lg transition duration-300 hover:scale-105 cursor-pointer select-none">
          Разбрах
        </button>
      </div>

    </div>
  </div>
}
